export default __webpack_public_path__ + "static/tag-do-2-dark-fa0eedd0942e99f480429807679ec3959c90e820c264e0e8bba5a29207d1253f.png";